import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "toggleButton", "title", "filterBadge"]

  connect() {
    this.activeFilter = null
  }

  filter(event) {
    const value = event.currentTarget.dataset.filterValue
    const isActive = this.activeFilter === value

    // Toggle: clicking the same filter again clears it
    this.activeFilter = isActive ? null : value

    // Update badge styles
    this.filterBadgeTargets.forEach(badge => {
      const selected = badge.dataset.filterValue === this.activeFilter
      badge.classList.toggle("border-[#5a36e6]", selected)
      badge.classList.toggle("bg-[#f5f3ff]", selected)
      badge.classList.toggle("text-[#5a36e6]", selected)
      badge.classList.toggle("border-[#E4E5E8]", !selected)
      badge.classList.toggle("bg-[#FAFAFB]", !selected)
      badge.classList.toggle("text-[#5F6672]", !selected)
    })

    // Filter cards
    const cards = this.element.querySelectorAll("[data-template-badge]")
    cards.forEach(card => {
      if (!this.activeFilter || card.dataset.templateBadge === this.activeFilter) {
        card.classList.remove("hidden")
      } else {
        card.classList.add("hidden")
      }
    })
  }

  close() {
    // Hide the sidebar - use !hidden to override lg:flex
    this.sidebarTarget.classList.add("!hidden")

    // Dispatch event to notify parent about sidebar state change
    this.dispatch("closed", { bubbles: true })
  }

  open() {
    // Show the sidebar - remove !hidden to restore lg:flex behavior
    this.sidebarTarget.classList.remove("!hidden")

    // Dispatch event to notify parent about sidebar state change
    this.dispatch("opened", { bubbles: true })
  }
}
